<script>
export default {
    props: {
        options: {
            type: Object,
            required: true
        },

        selectedTab: {
            type: Object,
            required: true
        },
        
        customStyle: {
            type: Object,
            required: false
        },
    },

    methods: {
        emit(o) {
            if (o.value === this.selectedTab) return;
            this.$emit('select-tab', o);
        },
    },
}
</script>

<template>
    <div class="tab-selector"
        :style="customStyle"
    >
        <button v-for="o in options" :key="o.value"
            :is-selected="selectedTab === o.value"
            @click="emit(o)"
        >
            {{ o.text }}
        </button>
    </div>
</template>

<style lang='scss' scoped>
    .tab-selector {
        width: 50%;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: stretch;
        
        overflow: hidden !important;
        border: 0 !important;
        outline: thin solid var(--sustainfinity-navy);
        border-radius: 1em;

        > button {
            flex: 1;
            outline: 0 !important;
            border-top: 0 !important;
            border-bottom: 0 !important;
            border-left: 0 !important;
            border-right: thin solid var(--sustainfinity-navy);
            background-color: whitesmoke;
            color: var(--sustainfinity-navy);

            transition: background-color 150ms;

            &:last-of-type {
                border-right: 0 !important;
            }

            &[is-selected] {
                background-color: var(--sustainfinity-navy) !important;
                color: whitesmoke !important;
            }
        }
    }
</style>